import {
  use2FAState,
  useFormattedFirstFactor,
} from "Login/TwoFA/API/queryHooks";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";
import {
  useAccentColor,
  useIsDark,
  useIsLegacy,
  useUsePassword,
} from "Login/TwoFA/stateHooks";

import fnrInputTypes from "UI/FnrInput2/fnrInputTypes";
import FnrTextButton from "UI/FnrTextButton";
import FnrTypeNSave from "UI/FnrTypeNSave";
import FauxInput from "UI/FnrTypeNSave/FauxInput";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

import FactorDisplay from "../../FactorDisplay";
import PromptTypography from "../../PromptTypography";
import ContainedCompactStartOver from "../../StartOver/ContainedCompactStartOver";

const FirstFactorPassword = () => {
  const { password, setPassword, stoutInputs, firstFactor } = useTwoFAContext();
  const [{ isLoading, firstFactorType }, refetch] = use2FAState();
  const [, setUsePassword] = useUsePassword();

  const accentColor = useAccentColor();
  const formattedFirstFactor = useFormattedFirstFactor();
  const isLegacy = useIsLegacy();
  const isDark = useIsDark();
  const handleUseMyCode = () => setUsePassword(false);

  return (
    <FnrVerticalGap data-cy="TwoFA_FirstFactorPassword">
      <FnrHorizontalGap gap={4}>
        <ContainedCompactStartOver />
        <div>
          <PromptTypography>Enter the password for:</PromptTypography>
          <br />
          <FactorDisplay type={firstFactorType}>
            {formattedFirstFactor}
          </FactorDisplay>
        </div>
      </FnrHorizontalGap>
      <FnrVerticalGap gap={4}>
        <FnrTypeNSave
          data-cy="TwoFA_FirstFactorPassword_Input"
          value={password}
          setValue={setPassword}
          type={fnrInputTypes.password}
          onSubmit={refetch}
          buttonText="Next"
          autofocus
          aria-label="account-password"
          buttonColor={accentColor}
          iconColor={accentColor}
          isLoading={isLoading}
          focusColor={accentColor}
          isLegacy={isLegacy}
          stout={stoutInputs}
          size="lg"
          autoComplete="current-password"
        >
          <FauxInput
            aria-label="account-phone-or-email"
            autoComplete="username"
            value={firstFactor}
          />
        </FnrTypeNSave>
        <FnrHorizontalGap centered>
          <FnrTextButton
            icon="fa-ellipsis-h fas"
            iconSide="right"
            onClick={handleUseMyCode}
            data-cy="TwoFA_GoToCode"
            isLegacy={isLegacy}
            isDark={isDark}
            subtleHover
            color="brandFnBlue"
            fontSize="sm"
          >
            Use my code
          </FnrTextButton>
        </FnrHorizontalGap>
      </FnrVerticalGap>
    </FnrVerticalGap>
  );
};
export default FirstFactorPassword;
